import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import apiService from "../../../Services/authenticationServices";
import { useB2cOrders } from "./B2cOrders";
import { convertUTCDate, getPrescriptionSrcType } from "../../../Utils/utilServices";
import { toast } from "react-toastify";
import { fmtDateTime } from "../../../Utils/dateFormat";

const OrderHeaderAccordion = ({
  data,
  index,
  isOpen,
  onToggle,
  onClose,
  warehouseList,
}) => {
  const scrollRef = useRef(null);
  const bgColor = index % 2 === 0 ? "bg-[#f6f5f1]" : "bg-[#FFFFFF]";
  const [orderDetails, setorderDetails] = useState([]);
  const [enquiryId, setenquiryId] = useState(data.id);
  const [showPrescription, setShowPrescription] = useState(false);
  const [prescriptionUrls, setPrescriptionUrls] = useState([]);
  const [view, setview] = useState(false);
  const [showTransferPopup, setShowTransferPopup] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(data.hospitalId);
  const drefaultWarehouse = data.hospitalId;

  const slaList = [
    { name: "0 -12 Hours", value: 1 },
    { name: "12-24 Hours", value: 2 },
    { name: "24-36 Hours", value: 3 },
    { name: "36-48 Hours", value: 4 },
    { name: "48-60 Hours", value: 5 },
    { name: "60-72 Hours", value: 6 },
    { name: "72 Hrs-1 Week", value: 7 },
    { name: "Cannot be supplied", value: 8 },
    { name: "CureBay Preferred Medicine ", value: 9 },
  ];

  const columns = [
    { field: "drugName", header: "Drug Name" },
    { field: "drugCode", header: "Drug Code" },
    { field: "drugsInfoComposition", header: "Composition & Strength" },
    { field: "quantity", header: "Quantity" },
    { field: "unitPrice", header: "Unit Price" },
    { field: "totalAmount", header: "Payable Amount" },
  ];

  const formatAddress = (...parts) => parts.filter(Boolean).join(", ");

  const fetchData = async () => {
    try {
      const payload = {
        patientDrugPrescriptionOrderId: data.orderId,
        status: 1,
      };

      const response = await apiService.getOrderDetails(payload);
      const enquiryList = response.data.successList;
      setorderDetails(enquiryList);
    } catch (err) {
      console.error("Error fetching order details:", err);
    }
  };

  const getSlaName = (value) => {
    const slaItem = slaList.find((item) => item.value === value || "");
    return slaItem?.name ?? "";
  };

  const viewPrescription = async (orderData) => {
    setview(true);
    const urls = [];

    const buildLegacyEntry = (file) => {
      const extension = file.split(".").pop().toUpperCase();
      const url = process.env.REACT_APP_API_GCP_URL + file;

      switch (extension) {
        case "PDF":
          return { url, srcType: "application/pdf" };
        case "JPG":
          return { url, srcType: "image/jpg" };
        case "JPEG":
          return { url, srcType: "image/jpeg" };
        case "PNG":
          return { url, srcType: "image/png" };
        default:
          return { url, srcType: "application/octet-stream" };
      }
    };

    const processFiles = async (filesStr) => {
      if (!filesStr) return;
      const files = filesStr.split(",");

      const filePromises = files.map(async (file) => {
        if (!file) return;
        const response = await apiService.getDocumentUrl(file);
        if (response?.status === 200 && response?.data?.SIGNED_URL) {
          urls.push({ url: response.data.SIGNED_URL, srcType: getPrescriptionSrcType(file) });
        } else {
          console.warn("getDocumentUrl failed (500 or otherwise), falling back to the old REACT_APP_API_GCP_URL behavior for", file, response);
          urls.push(buildLegacyEntry(file));
        }
      });

      await Promise.all(filePromises);
    };

    await processFiles(orderData.prescriptionDoc);
    if (orderDetails && orderDetails.length > 0) {
      await processFiles(orderDetails[0].prescriptionUrl);
    }

    if (urls.length > 0) {
      setPrescriptionUrls(urls);
      setShowPrescription(true);
    } else {
      toast.error("No prescription available for this order");
    }
  };


  const isMedsNow = (data.shipments || []).some(
    (sh) => sh?.shipmentType === "EXPRESS_30",
  );

  const headerFields = [
    {
      label: "Order Date",
      value: fmtDateTime(data.modifiedDate),
      width: "w-[45%] sm:w-[12%]",
    },
    {
      label: "Order ID",
      value: data.orderId,
      width: "w-[45%] sm:w-[12%]",
    },
    {
      label: "Patient ID",
      value: data.patientId,
      width: "w-[45%] sm:w-[12%]",
    },
    {
      label: "Patient Name",
      value: data.patientName,
      width: "w-[45%] sm:w-[12%]",
    },
    {
      label: "Mobile No.",
      value: data.patientMobile,
      width: "w-[45%] sm:w-[12%]",
    },
    {
      label: "Patient Address",
      value:
        data.patientAddress ||
        formatAddress(
          data.deliveryAddress1,
          data.deliveryAddress2,
          data.deliveryAddress3,
        ),
      width: "w-[45%] sm:w-[20%]",
    },
    {
      label: "Amount",
      value: data.paidAmount,
      width: "w-[45%] sm:w-[20%]",
    },
  ];

  const submitOrder = async (e) => {
    try {
      let payload = {};
      e == "C"
        ? (payload = {
          orderId: data.orderId,
          procedureStatus: 1,
          status: data.status,
        })
        : (payload = {
          orderId: data.orderId,
          procedureStatus: 0,
          status: 8,
        });

      const res = await apiService.submitorderDetails(payload);
      if (res.data.responseCode === "200") {
        e == "C"
          ? toast.success("Order Submitted Successfully")
          : toast.success("Order Updated Successfully");
        onClose();
      }
      setview(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to submit order");
    }
  };

  const handleTransferOrder = async () => {
    if (!selectedWarehouse) {
      toast.error("Please select a warehouse");
      return;
    } else if (drefaultWarehouse == selectedWarehouse) {
      let pharmacyName = warehouseList.find(
        (item) => item.pharmacyCode === selectedWarehouse,
      )?.pharmacyName;
      toast.error(
        `Please select a different warehouse. This order is already in ${pharmacyName} warehouse.`,
      );
      return;
    }
    try {
      const payload = {
        orderId: data.orderId,
        hospitalId: selectedWarehouse,
        locationId: warehouseList.find(
          (item) => item.pharmacyCode === selectedWarehouse,
        )?.locationCode,
      };

      const response = await apiService.transferOrder(payload);
      if (response.data.responseCode === "200") {
        toast.success(response.data.successObject.message);
        setShowTransferPopup(false);
        onClose();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to transfer order",
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while transferring the order");
    }
  };

  useEffect(() => {
    setview(false);

    if (isOpen) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      fetchData();
    }
  }, [isOpen, data.orderId]);

  useEffect(() => {
    if (!isOpen) {
      setShowPrescription(false);
      setShowTransferPopup(false);
      setview(false);
      setPrescriptionUrls([]);
    }
  }, [isOpen]);

  return (
    <div ref={scrollRef} className={`relative border rounded ${bgColor} my-3`}>
      {isMedsNow && (
        <span className="absolute top-0 left-0 z-10 px-2 py-0.5 rounded-tl rounded-br bg-[#336b3b] text-white text-[10px] font-bold tracking-wide">
          MEDS NOW
        </span>
      )}

      <div
        onClick={onToggle}
        className="cursor-pointer px-2 sm:px-4 flex justify-between items-center"
      >
        <div className={`flex-1 min-w-0 p-4 ${isMedsNow ? "pt-6" : ""}`}>
          <div className="flex flex-wrap sm:flex-nowrap overflow-auto text-xs gap-3 sm:gap-5">
            {headerFields.map(({ label, value, width }, i) => (
              <span key={i} className={`${width} break-words`}>
                <span className="text-gray-500">{label}:</span> {value}
              </span>
            ))}
          </div>
        </div>
        <span className="text-gray-600 text-xl">
          {isOpen ? <HiChevronUp /> : <HiChevronDown />}
        </span>
      </div>

      {isOpen && <div className="h-[1px] bg-gray-300 w-full" />}

      {isOpen && (
        <div className="p-4 pb-8 bg-white overflow-auto">
          {isMedsNow && (
            <div className="mb-3">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-[#336b3b] text-white text-[11px] font-bold tracking-wide">
                  <span className="h-1.5 w-1.5 rounded-full bg-white" />
                  MEDS NOW
                </span>
            </div>
          )}
          <div className="flex flex-wrap gap-2 justify-between mb-3">
            <div>
              <button
                className="bg-[#336b3b] text-white px-4 py-2 rounded-md mr-2"
                onClick={() => submitOrder("C")}
              >
                Submit
              </button>
              {data.prescriptionDoc && (
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                  onClick={() => viewPrescription(data)}
                >
                  View Prescription
                </button>
              )}
              <button
                className="bg-[#5841a0] text-white px-4 py-2 rounded-md mr-2 hover:bg-purple-600"
                onClick={() => setShowTransferPopup(true)}
              >
                Transfer
              </button>
            </div>
          </div>

          <div className="overflow-x-auto border border-[#1d2f5b] rounded-md">
            <div className="min-w-full inline-block align-middle">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-[#1d2f5b] text-white">
                    <tr>
                      {columns.map((column, index) => (
                        <th key={index} className="p-2 font-semibold">
                          {column.header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.map((item) => (
                      <tr key={item.id} className="border-t">
                        {columns.map((column) => {
                          if (column.field === "deliverySlaStatus") {
                            return (
                              <td
                                key={column.field}
                                className="p-2 whitespace-nowrap"
                              >
                                {getSlaName(item[column.field])}
                              </td>
                            );
                          }
                          return (
                            <td key={column.field} className="p-2">
                              {item[column.field] ?? "-"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showPrescription && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-0">
              <div className="bg-white p-4 rounded-lg max-w-4xl w-full max-h-[90dvh] sm:max-h-screen overflow-auto">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Prescription</h2>
                  <button
                    onClick={() => setShowPrescription(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  {prescriptionUrls.map((item, index) => (
                    <div key={index} className="border rounded p-2">
                      {item.srcType.includes("image/") ? (
                        <img
                          src={item.url}
                          alt={`Prescription ${index + 1}`}
                          className="w-full h-auto mx-auto"
                        />
                      ) : item.srcType === "application/pdf" ? (
                        <iframe
                          src={item.url}
                          className="w-full h-[500px]"
                          title={`PDF Prescription ${index + 1}`}
                        ></iframe>
                      ) : (
                        <div className="p-4 text-center">
                          <p>Unsupported file type: {item.srcType}</p>
                          <a
                            href={item.url}
                            download
                            className="text-blue-500 hover:underline"
                          >
                            Download File
                          </a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {showTransferPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-0">
              <div className="bg-white p-4 sm:p-6 rounded-lg max-w-md w-full">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Transfer Order</h2>
                  <button
                    onClick={() => setShowTransferPopup(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {warehouseList && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Select Warehouse
                    </label>
                    <select
                      value={selectedWarehouse}
                      onChange={(e) => setSelectedWarehouse(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md"
                    >
                      <option value="">Select a warehouse</option>
                      {warehouseList?.map((warehouse) => (
                        <option
                          key={warehouse.pharmacyCode}
                          value={warehouse.pharmacyCode}
                        >
                          {warehouse.pharmacyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowTransferPopup(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleTransferOrder}
                    className="px-4 py-2 bg-[#5841a0] text-white rounded-md hover:bg-purple-600"
                  >
                    Confirm Transfer
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const B2cReceived = forwardRef((props, ref) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [orders, setOrders] = useState([]);
  const [invalidList, setinvalidList] = useState([]);
  const [sortOrder, setSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [warehouseList, setwarehouseList] = useState([]);
  const { filter, setFilterField } = useB2cOrders();

  /* Only the newest request may update the list, so a slow older response
     can't replace the results of a newer filter. */
  const latestFetch = useRef(0);

  const fetchData = async (pageNo = 1) => {
    const seq = ++latestFetch.current;
    try {
      const payload = {
        procedureStatus: 0,
        pageNumber: pageNo,
        orderBy: sortOrder === 1 ? "DESC" : "ASC",
        orderSource: "B2C",
        ...Object.fromEntries(
          Object.entries(filter).filter(
            ([_, val]) => val !== null && val !== undefined && val !== "",
          ),
        ),
      };
      if (payload.fromDate && payload.toDate) {
        payload.fromDate = convertUTCDate(payload.fromDate);
        payload.toDate = convertUTCDate(payload.toDate);
      }
      const response = await apiService.getmedicineOrders(payload);
      if (seq !== latestFetch.current) return;
      let orderList = response.data.successList || [];
      let invalid = [];
      if (sortOrder == 2) {
        invalid = orderList.filter((order) => order.status == 8);
        setOrders(invalid);
      } else {
        orderList = orderList.filter((order) => order.status !== 8);
        setOrders(orderList);
      }
      setCurrentPage(pageNo);
      setHasNextPage(orderList.length > 0);
    } catch (err) {
      if (seq !== latestFetch.current) return;
      console.error("Failed to fetch orders", err);
      setOrders([]);
      setHasNextPage(false);
    }
  };

  const fetchWarehouseData = async () => {
    try {
      const response = await apiService.getwareHouseDetails();
      setwarehouseList(response.data.successList || []);
    } catch (err) {
      console.error("Error fetching warehouse details:", err);
      toast.error("Failed to load warehouse data");
    }
  };

  const handleNextPage = () => {
    fetchData(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchData(currentPage - 1);
    }
  };

  useEffect(() => {
    fetchData(1);
    fetchWarehouseData();
  }, [filter, sortOrder]);

  useImperativeHandle(ref, () => ({
    onSearch: () => fetchData(1),
  }));

  const handleToggle = (index) => {
    if (sortOrder != 2) {
      setOpenIndex((prev) => (prev === index ? null : index));
    } else {
      return toast.error(
        "This order has an invalid prescription. The clinic staff will attach a new prescription",
      );
    }
  };

  const handleSortChange = (value) => {
    if (value == 2) {
      setOpenIndex(null);
    }
    setSortOrder(value);
  };

  return (
    <div className="pl-1 pr-1 sm:pr-6 min-h-screen">
      <div className="flex flex-wrap items-center gap-4 ml-4 mb-4">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="newest"
            checked={sortOrder === 1}
            onChange={() => handleSortChange(1)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Newest First</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="oldest"
            checked={sortOrder === 0}
            onChange={() => handleSortChange(0)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Oldest First</span>
        </label>
      </div>

      {orders.map((order, index) => (
        <OrderHeaderAccordion
          key={index}
          data={order}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
          onClose={() => {
            fetchData();
            setOpenIndex(null);
          }}
          warehouseList={warehouseList}
        />
      ))}

      <div className="flex flex-wrap justify-center items-center mt-4 mb-8 gap-2">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Previous
        </button>

        <button
          onClick={() => fetchData(1)}
          className={`px-4 py-2 border rounded ${currentPage === 1 ? "bg-blue-100" : ""}`}
        >
          1
        </button>

        {currentPage > 1 && (
          <button
            onClick={() => fetchData(currentPage)}
            className="px-4 py-2 border rounded bg-blue-100"
          >
            {currentPage}
          </button>
        )}

        <button
          onClick={handleNextPage}
          disabled={!hasNextPage}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
});

export default B2cReceived;
